import { Component } from '@angular/core';
import { ProcessingManager } from '@managers/processing.manager';
import { BaseComponent } from '../../../base.component';
import { ProcessingStep } from '@models/ui/processing-step.model';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { animate, style, transition, trigger } from '@angular/animations';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationManager } from '@managers/notification.manager';

@Component({
    selector: 'lex-processing-details-pane',
    templateUrl: './processing-details-pane.component.html',
    styleUrls: ['./processing-details-pane.component.scss'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ marginRight: '-480px' }),
                animate('350ms ease-in-out', style({ marginRight: '0' }))
            ]),
            transition(':leave', [
                style({ marginRight: '0' }),
                animate('350ms ease-in-out', style({ marginRight: '-480px' }))
            ])
        ])
    ],
    standalone: false
})
export class ProcessingDetailsPaneComponent extends BaseComponent {
	public currentStep: ProcessingStep;

	constructor(
		private processingManager: ProcessingManager,
		private router: Router,
		private clipboard: Clipboard,
		private notificationService: NotificationManager
	) {
		super();

		this.processingManager.currentActiveStep$.pipe(
			switchMap((stepId) => this.processingManager.getProcessingStepDetails(stepId))
		).subscribe((step) => {
			this.currentStep = step;
		});

	}

	public close(): void {
		this.currentStep = null;
		this.router.navigate(['/', 'processing', 'queue', 'snapshot']);
	}

	public copyParamsToClipboard() {
		const text = JSON.stringify(this.currentStep.stepParams, null, 4);
		this.clipboard.copy(text);
		this.notificationService.displaySnackBarMessage({
			message: 'Step params copied to clipboard!'
		});
	}

	public copyDocumentIdToClipboard() {
		this.clipboard.copy(this.currentStep.documentId);
		this.notificationService.displaySnackBarMessage({
			message: 'DocumentId copied to clipboard!'
		});
	}

	public copyCaseIdToClipboard() {
		this.clipboard.copy(this.currentStep.caseId);
		this.notificationService.displaySnackBarMessage({
			message: 'CaseId copied to clipboard!'
		});
	}
}
